import React, { useState } from 'react';
import NewSubjectModal from '../../../components/NewSubjectModal';
import { Card } from '../../../components/ui';

const EmptyState = () => {
  const [showNewSubjectModal, setShowNewSubjectModal] = useState(false);

  return (
    <div
      className="flex-auto flex items-center justify-center mb5"
      data-testid="dashboard-empty-state"
    >
      <div className="pv2 pv4-ns w-100" style={{ maxWidth: 702 }}>
        <Card className="tc center mb2" data-testid="new-tracker-card">
          <div className="pa4">
            <h2 className="f5 fw6 mv2">Create a Subject</h2>
            <p className="f7 serif lh-copy measure mt0 mb3 center">
              A Subject is one of your team’s shared concerns, like a client, customer, product, or
              project.
            </p>
            <button
              onClick={() => setShowNewSubjectModal(true)}
              data-testid="new-subject-button"
              className="f6 blue hover-navy mb2"
            >
              New Subject
            </button>
          </div>
        </Card>

        {showNewSubjectModal && (
          <NewSubjectModal closeModal={() => setShowNewSubjectModal(false)} redirectToSubject />
        )}
      </div>
    </div>
  );
};

export default EmptyState;
